import { AUTH_CLIENT_COOKIE_OPTIONS_LAX, AUTH_CLIENT_COOKIE_OPTIONS_PARTITIONED } from '~/types/cookieOptions';
import { useIsInIframe } from '~/composables/useIsInIframe';

export function useIframeAuthFlow() {
    const { isDraftModeEnabled } = useDraftMode();

    const shouldUseIframeAuthFlow = computed(() => isDraftModeEnabled.value && useIsInIframe() && import.meta.client);

    const cookieOptions = computed(() =>
        isDraftModeEnabled.value && useIsInIframe()
            ? AUTH_CLIENT_COOKIE_OPTIONS_PARTITIONED
            : AUTH_CLIENT_COOKIE_OPTIONS_LAX
    );

    return {
        cookieOptions,
        shouldUseIframeAuthFlow
    };
}
